import { generateUnOrderedList } from "../../../screens/JaldiLab/Chapters/ChapterList"

export const FigureDesc45 = {
    title: "Figure 45: Typical floor plan for a Judge’s chamber.",
    para1: <>
        <p><span><b>Orientation of the floor plan: </b></span>
            This image shows the floor plan of the Judge’s Chamber. Two entrances to the Judge’s chamber are provided at the bottom and right of the floor plan respectively. The features of the room are described from the bottom to the top, starting from the entrance at the bottom.
        </p>
        <p><span><b>Description: </b></span>
            <div className="figure_desc">
                {generateUnOrderedList([
                    "An accessible entrance to the Chamber is provided at the bottom of the layout, with a turning diameter of 1500 mm. ",

                    "Upon entering, seating space is provided with sofas and a centre table.",

                    "A second entrance to the Chamber is provided at the right, through the Judges’ Corridor. The entrance is wheelchair-accessible.",

                    "At the top of the layout, a table with chairs is provided for the Judge and for stenographers/clerks towards the side of the table. The table is equipped with digital technology including computer systems.",

                    "Storage is provided along the walls at the top and left sides of the layout.",

                    "To the left of the Judge’s seating area, a door leads to a dressing area (1750 mm x 1500 mm) for Judges.",

                    "The dressing area has an attached gender-neutral, accessible washroom (2200 mm x 2000 mm). The washroom has a western water closet and a basin, with a turning diameter of 1500 mm.",

                ])}
            </div>
        </p>
    </>
}

export const FigureDesc46 = {
    title: "Figure 46: Representation of a Judge’s chamber.",
    para1: <>
        <p><span><b>Orientation of the floor plan: </b></span>
            This image shows a 3D rendering of the plan for the Judge’s Chamber. Two entrances to the Judge’s chamber are provided at the bottom and right of the floor plan. The features are described from the bottom to the top.
        </p>
        <p><span><b>Description: </b></span>
            <div className="figure_desc">
                {generateUnOrderedList([
                    "An accessible entrance to the Chamber is provided at the bottom of the layout.",

                    "Upon entering, seating space is provided with sofas and a centre table.",

                    "A second accessible entrance to the Chamber is provided at the right, through the Judges’ Corridor. ",

                    "At the top of the layout, a table with chairs is provided for the Judge and a second table is provided for stenographers/clerks towards the side of the table. The table is equipped with digital technology including computer systems.",

                    "Storage is provided along the walls at the top and left of the layout.",

                    "To the left of the Judge’s seating area, a door leads to a cloak room for Judges.",

                    "The cloak room has an attached gender-neutral, accessible washroom.",

                ])}
            </div>
        </p>
    </>
}

export const FigureDesc47 = {
    title: "Figure 47: Typical floor plan for a PDJ chamber. ",
    para1: <>
        <p><span><b>Orientation of the floor plan: </b></span>
            This figure shows a floor plan of a PDJ Chamber (6800 mm x 4450 mm). The entrance to the PDJ chamber from the corridors leading to the administrative offices is provided at the bottom-centre of the floor plan. An additional door is provided from the Judges’ corridor to the chamber at the right of the floor plan. The features of the room are described bottom to top.
            <div className="figure_desc">
                {generateUnOrderedList([
                    "There is an entrance door at the bottom top of the PDJ chamber. The entrance is accessible with a turning diameter of 1500 mm. ",

                    "To the left of the entrance, space is provided for a meeting area. The meeting area comprises a sofa set with a centre table.",

                    "To the right of the entrance, along the wall, space is provided for storage.",

                    "In front of the storage area, space is provided for seating. There is a table and 4 chairs, including wheelchair-accessible seating.",

                    "A door is provided at the right side of the layout, leading to a pathway to the Judge’s corridor which is wheelchair-accessible.",

                    "At the top of the chamber, the Judges’ desk is provided, with seating for the Judge on one side and two chairs opposite. The Judge sits in the direction facing the entrance door.",

                    "To the left of the Judges’ desk and adjoining it, a desk and chair for the stenographer/clerk is provided. The judges’ desk and the stenographer/clerk’s desk is equipped with digital technology, including computer systems.",

                    "Behind the Judge’s table, along the wall, space is provided for storage.",

                    "To the left of the Judge’s work space, there is a door which leads to the dressing area (1750 mm x 1500 mm). The dressing area has storage and acts as a space where the Judge can change before going into Court.",

                    "The dressing area has an attached gender-neutral accessible washroom with a turning diameter of 1500 mm. The washroom has a western water closet and a basin. ",

                ])}
            </div>
        </p>
    </>
}

export const FigureDesc48 = {
    title: "Figure 48: Representation of a Judge’s chamber. ",
    para1: <>
        <p><span><b>Orientation of the floor plan: </b></span>
            This image shows a 3D rendering of the plan for the Judge’s Chamber. Two entrances to the Judge’s chamber are provided at the bottom and right of the floor plan. The features are described from the bottom to the top.
        </p>
        <p><span><b>Description: </b></span>
            <div className="figure_desc">
                {generateUnOrderedList([
                    "An accessible entrance to the Chamber is provided at the bottom of the layout.",

                    "Upon entering, seating space is provided to the left with sofas and a centre table.",

                    "To the right of the entrance, a desk with four chairs is provided. The desk is equipped with digital technology, including computer systems.",

                    "A second accessible entrance to the Chamber is provided at the right, through the Judges’ Corridor.",

                    "At the top of the layout, a table with chairs is provided for the Judge and a second table is provided for stenographers/clerks towards the side of the table. The table is equipped with digital technology including computer systems.",

                    "Storage is provided along the walls at the top and left of the layout.",

                    "To the left of the Judge’s seating area, a door leads to a cloak room for Judges.",

                    "The cloak room has an attached gender-neutral, accessible washroom.",

                ])}
            </div>
        </p>
    </>
}


